<div *ngIf="(show$ | async)">
    <router-outlet></router-outlet>
</div>
